class GoogleAnalyticsService {

  /*@ngInject*/
  constructor($window) {
    this.$window = $window
  }

  submitConversionTrackingEvent(orderReference, orderValue, cartage, productLinesWithSKU, origin) {

    try {
      //  AdWords campaign conversion
      this.$window.google_trackConversion({
        google_conversion_id: 1056636569,
        google_conversion_language: 'en',
        google_conversion_format: '3',
        google_conversion_color: 'ffffff',
        google_conversion_label: 'rqJ8CJ3PtlkQmf3r9wM',
        google_conversion_value: orderValue,
        google_conversion_currency: 'AUD',
        google_remarketing_only: false
      });
    }
    catch(exception) {
      //  Firefox privacy mode blocks ad services and analytics libraries from loading
    }

    //  Use the dataLayer object to push ECommerce tracking information
    this.$window.dataLayer = this.$window.dataLayer || [];

    this.$window.dataLayer.push({
      'event': 'transactionComplete',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': orderReference, // Transaction ID. Required for purchases and refunds.
            'affiliation': 'Online Store',
            'revenue': orderValue, // Total transaction value (incl. tax and shipping)
            'shipping': cartage
          },
          'products': productLinesWithSKU
        }
      },
      'dimension1': origin
    });
  }
}

export default GoogleAnalyticsService;


// WEBPACK FOOTER //
// ./src/app/services/google-analytics-service.js